export default {
  getCountries (state) {
    return state.countries
  },
  getSelectedCountries (state) {
    return state.selectedCountries
  },
  getCountryById (state) {
    return id => state.countries.find(item => { return Number(item.id) === Number(id) })
  },
  getSelectedCountriesById (state) {
    return id => state.selectedCountries.find(item => { return Number(item.id) === Number(id) })
  },
  getStates (state) {
    return state.states
  },
  getSelectedStates (state) {
    return state.selectedStates
  },
  getSelectedStatesById (state) {
    return id => state.selectedStates.find(item => { return Number(item.id) === Number(id) })
  },
  getStateById (state) {
    return id => state.states.find(item => { return Number(item.id) === Number(id) })
  },
  getCities (state) {
    return state.cities
  },
  getSelectedCities (state) {
    return state.selectedCities
  },
  getSelectedCitiesById (state) {
    return id => state.selectedCities.find(item => { return Number(item.id) === Number(id) })
  },
  getCityById (state) {
    return id => state.cities.find(item => { return Number(item.id) === Number(id) })
  },
  getLanguages (state) {
    return state.languages
  },
  getSelectedLanguages (state) {
    return state.selectedLanguages
  },
  getSelectedLanguagesById (state) {
    return id => state.selectedLanguages.find(item => { return Number(item.id) === Number(id) })
  },
  getLanguageById (state) {
    return id => state.languages.find(item => { return Number(item.id) === Number(id) })
  },
  getCountryMap (state) {
    return state.countryMap
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js